import './SkeletonLoading.style.less'
import { Skeleton } from 'antd'

function SkeletonLoading() {
  return (
    <div>
      <Skeleton active />
    </div>
  )
}

export default SkeletonLoading
